import React from 'react';
import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '../../../../../contexts/translations-context';
import { ResellerFlowNotificationDataHooks } from './data-hooks';

export interface ResellerFlowNotificationProps {
  appName: string;
}

export function ResellerFlowNotification({
  appName,
}: ResellerFlowNotificationProps) {
  const { t } = useTranslation();

  return (
    <SectionHelper
      layout="horizontal"
      dataHook={ResellerFlowNotificationDataHooks.container}
      appearance="standard"
      title={t('app.page.reseller.flow.notification.title')}
      fullWidth
    >
      <Box direction="vertical" gap="9px">
        <Text
          dataHook={ResellerFlowNotificationDataHooks.description}
          size="small"
          weight="thin"
        >
          {t('app.page.reseller.flow.notification.subtitle', {
            appName,
          })}
        </Text>
        <TextButton
          as="a"
          href={t('app.page.reseller.flow.notification.learn.more.link')}
          target="_blank"
          size="small"
          weight="thin"
          underline="always"
          skin="dark"
        >
          {t('app.page.reseller.flow.notification.learn.more.label')}
        </TextButton>
      </Box>
    </SectionHelper>
  );
}
